/*
 * @flow strict
 * Copyright (C) 2018 MetaBrainz Foundation
 *
 * This file is part of MusicBrainz, the open internet music database,
 * and is licensed under the GPL version 2, or (at your option) any
 * later version: http://www.gnu.org/licenses/gpl-2.0.txt
 */

import SelectField from '../../common/components/SelectField.js';

import FieldErrors from './FieldErrors.js';
import FormLabel from './FormLabel.js';
import FormRow from './FormRow.js';
import HiddenField from './HiddenField.js';

component FormRowSelect(
  // `allowEmpty` prepends an empty default option to the list.
  allowEmpty: boolean = false,
  disabled: boolean = false,
  field: FieldT<number | string>,
  frozen: boolean = false,
  hasHtmlErrors?: boolean,
  helpers?: React.Node,
  label: React.Node,
  onChange?: (event: SyntheticEvent<HTMLSelectElement>) => void,
  onFocus?: (event: SyntheticEvent<HTMLSelectElement>) => void,
  options: MaybeGroupedOptionsT,
  /*
   * `required` makes the field text bold to indicate a selection is required.
   * Only useful when `allowEmpty` is true.
   */
  required as passedRequired: boolean = false,
  rowRef?: {writeonly current: HTMLDivElement | null},
  uncontrolled: boolean = false,
) {
  let required = passedRequired;
  if (!allowEmpty) {
    // If the field can't be unset, there's nothing required from the user.
    required = false;
  }
  return (
    <FormRow rowRef={rowRef}>
      <FormLabel forField={field} label={label} required={required} />
      <SelectField
        allowEmpty={allowEmpty}
        disabled={disabled || frozen}
        field={field}
        onChange={onChange}
        onFocus={onFocus}
        options={options}
        required={required}
        uncontrolled={uncontrolled}
      />
      {frozen ? <HiddenField field={field} /> : null}
      {helpers}
      <FieldErrors field={field} hasHtmlErrors={hasHtmlErrors} />
    </FormRow>
  );
}

export default FormRowSelect;
